<template >
  <div class="position-relative" tabindex="1"  @focusout="verifyIfChildAndClose">
    <div>
      <!-- <div v-if="!$isMobile()" class="filter-label"><span class="title">  -->
      <div class="filter-label"><span class="title"> 
         <slot>
          {{ label }}
        </slot></span>
        <span @click="isDropdownOpen=!isDropdownOpen" class="d-flex align-items-center justify-content-between w-100">
          <span>{{ formattedSelected() }}</span> <i class="las la-angle-down la-xs icon-color icon-align"></i>
        </span>
      </div>
    </div>
    <!-- <div v-show="isDropdownOpen || $isMobile()" :class="[$isMobile() ? 'menu-list-mobile': 'menu-list content-container']">
                v-if="!$isMobile()"
 -->
    <div v-show="isDropdownOpen " :class="['menu-list content-container']">
      <base-input
        type="no-label"
        :remove_default_margin="true"
        ref="searchinp"
        cus_ref="ipsearch"
        :value.sync="searchOps"
        @change-value="handleSearch"
      > 
      <!-- Needs additional styling $isMobile() ? 'badge' : '', -->
      </base-input>
      <div class="d-flex justify-content-center clear-menu menu-item"
      @mouseenter="addClass"
      @mouseleave="removeClass"
       @click="resetChoices" >
        <base-button
            cus_style="margin: 1px 1px 1px 1px"
            stylevariant="hardlink"
        >All Merchants
        </base-button>
      </div>
      <div
        v-for="(menu_item) in filteredOptions()"
        :class="[
          'menu-item d-flex',
        ]"
        :key=menu_item.id
        @mouseenter="addClass"
        @mouseleave="removeClass"  
      >
        <b-form-checkbox :class="['mb-2 justify-left']"
        :checked="handlechecked(menu_item)"
        @input="evt => handleUpdate(menu_item, evt)"
        >
        &nbsp;&nbsp;&nbsp;{{ menu_item.name }}</b-form-checkbox>
        <div class="singleselect" @click="evt=>handleSingleSelect(menu_item, evt, 'single')"> </div>
      </div>
      <div class="d-flex justify-content-center clear-menu menu-item"
      @mouseenter="addClass"
      @mouseleave="removeClass"
       @click="resetChoices" >
        <base-button
            cus_style="margin: 1px 1px 1px 1px"
            stylevariant="hardlink"
        >Clear all
        </base-button>
      </div>
    </div>
  </div>
</template>
<script>
import BaseButton from './UI/BaseButton.vue';
import BaseInput from './UI/BaseInput.vue';
export default{
  
  name: "MultiselectDropdown",
  components:{BaseButton, BaseInput},
  props:  {
      disabled: {
        type: Boolean,
        default() {
          return false;
        },
      },
      multiple: {
        type: Boolean,
        default() {
          return false;
        },
      },
      options: {
        type: Array,
        default() {
          return [];
        },
      },
      originalOptions: {
        type: Array,
        default() {
          return [];
        },
      },
      placeholder: {
        type: String,
        default() {
          return `Select ${
            this.multiple ? "multiple merchants" : "merchant"
          }`;
        },
      },
      value: {
        type: Object | Array,
        default() {
          return {};
        },
      },
      label: {
        type: String,
        default() {
          return "";
        },
      },
      elementlable:{
        type: String,
        default() {
          return "";
        },
      },
      reduce: {
        type: Function,
        default: (option) => option,
      },
      filters: {
        type: Object,
        default() {
          return {};
        },
      },
    },
    components: {
      BaseInput,
    },
    mounted(){
      
    },
  methods: {
    resetChoices() {
      this.selected=[]
      this.searchOps ='';
      this.$emit("item-select", null);
      this.isDropdownOpen = false;
    },
    handleUpdate(menu_item, update) {
      if (update) {
        let checkifExists= this.selected.find((itm)=>itm.id === menu_item.id) !== undefined
        if(!checkifExists){
          let selectedItems = [...this.selected, menu_item]
          this.selected = selectedItems;
        }
      }
      else{
          let selectedItems = this.selected.filter(itm => itm.id !== menu_item.id);
          this.selected = selectedItems;
      }
    },
    handleSingleSelect(menu_item, event, type){
      if (event.type == 'click') {
        this.selected = this.options.filter((itm)=> itm.id == menu_item.id ); 
      }
    },
    handlechecked(menu_item, evt){
      if(this.selected.length >0){
        let selectedArr= this.selected.map((itm)=>itm.id)
        if(selectedArr.includes(menu_item.id)){
          return true
        }
        return false
      }
      else{
        return false
      }
      
    },
    handleSearch(event, field){
      this.searchOps = event
      this.filteredOptions();
    },
    verifyIfChildAndClose(evt){
      if (evt.relatedTarget) { 
        return;
      }
      else{
        this.isDropdownOpen = false;
      }
    },
    formattedSelected(){
      if (this.selected.length === 0) {
        return 'All Merchants';
      }
      else{
        return `${this.selected[0].name}${this.selected.length>1? " +"+(this.selected.length-1):""}`; 
      }
    },
    filteredOptions(){
      if (this.searchOps !== null && this.searchOps !== "") {
        return this.options.filter(key=> key.name.toLocaleLowerCase().includes(this.searchOps));
      } 
      return this.options;
    },
    addClass: function (e) {
      if (e.target.classList.contains("menu-item")) {
        e.target.classList.add("hovered");
      }
    },
    removeClass: function (e) {
      if (e.target.classList.contains("menu-item")) {
        e.target.classList.remove("hovered");
      }
    },
    focusInput(){
      this.$nextTick(() => {
        this.$refs.searchinp.$refs.ipsearch.focus();
      });
    }
  },
  watch: {
      isDropdownOpen (newVal) {
        this.focusInput();
        if (!newVal) {
          this.searchOps = "";
        }  
      },
      selected(newVal,oldval){
        let newValIds= newVal.map(obj=> obj.id).toString();
        let oldvalIds = oldval.map(obj=>obj.id).toString();
        if(newValIds !== oldvalIds ){
          this.$emit("item-select", newVal);
        }
      }
  },
  computed: {

  },
  data () {
    return {
      isDropdownOpen:false,
      searchOps:'',
      selected:[]
    }
  },

};
</script>
<style scoped lang="scss">
.content-container {
  @include content-container;
}

.menu-list {
  position: absolute;
  width: 90%;
  top: 3rem; 
  left: 0px;
  z-index: 99999;
}
.clear-menu{
  padding:5px;
  border-top:outset;
}

.title {
    @extend %title;
    color: #777777;
    font-size: 12px;
    position: absolute;
    bottom: 30px; 
    left: 1rem;
  }

  .filter-label {
    margin-right: 2rem;
    // margin-top: 1rem;
    min-width: 6rem;
    color: #111111;
    font-size: 15px;
    font-family: $brand-font-medium;
    cursor: pointer;
    border: 1px solid #edece9; 
    padding: 0.45rem 0.5rem; 
    border-radius: 6px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    background-color: white;
  }
  @media (max-width: 991.98px) {
    .filter-label {
      padding: 0.3rem 0.5rem;
    }
}
  .icon-color {
    color: #777777;
  }
  .icon-align{
    right: 3rem;
    // top: 1.5rem;
  }

  .justify-left{
    justify-content: left !important;
    padding-left: 2rem;
  }
  .hovered{
    background-color: #efeeed !important;
  }
  ::v-deep label.custom-control-label{
    width:max-content !important
  }
  .singleselect{
    width: -webkit-fill-available;
  }

</style>